(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/redirect-to-slug/assets/javascripts/redirect-to-game-template-container.js') >= 0) return;  svs.modules.push('/components/marketplace/redirect-to-slug/assets/javascripts/redirect-to-game-template-container.js');

'use strict';

const _excluded = ["id", "slug"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const _svs$components$marke = svs.components.marketplace.redirectToSlug,
  RedirectToSlug = _svs$components$marke.RedirectToSlug,
  helpers = _svs$components$marke.helpers;
const mapStateToProps = (_ref2, _ref) => {
  let Templates = _ref2.GameTemplates.Templates;
  let _ref$match = _ref.match,
    _ref$match$params = _ref$match.params,
    id = _ref$match$params.id,
    slug = _ref$match$params.slug,
    params = _objectWithoutProperties(_ref$match$params, _excluded),
    path = _ref$match.path,
    groupId = _ref.groupId;
  return {
    id: Number(id),
    name: (((Templates[groupId] || {}).data || []).find(t => t.id === Number(id)) || {}).name,
    prePath: helpers.getPathBeforeParam(path, ':id').split('/').map(part => {
      if (part.length === 0) {
        return part;
      }
      const paramRegEx = /(\w+)/;
      const _part$slice$match = part.slice(1).match(paramRegEx),
        _part$slice$match2 = _slicedToArray(_part$slice$match, 1),
        paramName = _part$slice$match2[0];
      if (!params[paramName]) {
        return part;
      }
      return part.replace(/^:/, '').replace(/\(([^)]+)\)/, '').replace(paramRegEx, params[paramName]);
    }).join('/'),
    slug
  };
};
setGlobal('svs.components.marketplace.redirectToSlug.RedirectToGameTemplateSlugContainer', ReactRedux.connect(mapStateToProps)(RedirectToSlug));

 })(window);